module.exports = __webpack_public_path__ + "static/odroidc2-e9859db9358bba99ade1bc3bc04e0acb.png";